/**
 * @generated SignedSource<<73b18c79b6a5d93c1eb77b3098522a22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuotasOverviewElementTable_element$data = {
  readonly label: string | null;
  readonly labeledText: string | null;
  readonly options: ReadonlyArray<{
    readonly qualified: number | null;
    readonly qualifiedTotal: number | null;
    readonly quota: string | null;
    readonly terminate: boolean | null;
    readonly text: string | null;
    readonly total: number | null;
  } | null> | null;
  readonly text: string | null;
  readonly type: string | null;
  readonly " $fragmentType": "QuotasOverviewElementTable_element";
};
export type QuotasOverviewElementTable_element$key = {
  readonly " $data"?: QuotasOverviewElementTable_element$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuotasOverviewElementTable_element">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuotasOverviewElementTable_element",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "labeledText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FieldReportOptionNode",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "qualified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "qualifiedTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quota",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "terminate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FieldReportElementNode",
  "abstractKey": null
};
})();

(node as any).hash = "6262268e67310f0884c57e19f0a5ffbd";

export default node;
